import { Role } from "../../../../../types/entrypoint";
import { Krr, User } from "../../../../../types/session";
import { Action } from "../actions";

type UserState = {
  auth: Role | "NONE";
  authIsRegistrering: boolean;
  info?: Partial<User>;
};

const initialState: UserState = {
  auth: "NONE",
  authIsRegistrering: false,
};

const defaultKrr = {
  epost: "",
  telefonnummer: "+47",
  countryCode: "+47",
  nationalNumber: "",
  region: "NO",
  noKrr: true,
};

export default function userReducer(
  state: UserState = initialState,
  action: Action,
): UserState {
  switch (action.type) {
    case "SESSION_FETCHED": {
      const auth = action.user ? action.user.authenticationRole : "NONE";
      const user =
        action.user && !action.user.krr
          ? { ...action.user, ...{ krr: defaultKrr } }
          : action.user;
      return {
        auth,
        authIsRegistrering: auth === "REGISTRATION",
        info: user,
      };
    }
    case "SET_PERSON_USER_INPUT": {
      const countryCode =
        action.input.countryCode === ""
          ? action.input.countryCode
          : action.input.countryCode ||
            (state.info && state.info.krr
              ? state.info.krr.countryCode
              : defaultKrr.countryCode);
      const nationalNumber =
        action.input.nationalNumber === ""
          ? action.input.nationalNumber
          : action.input.nationalNumber ||
            (state.info && state.info.krr
              ? state.info.krr.nationalNumber
              : defaultKrr.nationalNumber);

      const input: Partial<Krr> = {
        ...action.input,
        telefonnummer: countryCode.trim() + nationalNumber.trim(),
      };

      const krr: Krr = {
        ...(state.info?.krr ? state.info.krr : defaultKrr),
        ...input,
      };

      return {
        ...state,
        info: {
          ...state.info,
          krr,
        },
      };
    }
    default:
      return state;
  }
}
